module.exports = __webpack_public_path__ + "img/REAL.b4d098d9.png";